import colors from './colors';

const lightTheme = {
  name: 'light',
  colors: {
    primary: {
      main: colors.primary.blue,
      hover: '#1952E5',
      light: colors.background.slightPurple,
      dark: '#1444C7',
    },
    secondary: {
      main: colors.primary.red,
      hover: '#D93340',
      light: '#FFEBEC',
    },
    background: {
      default: colors.neutral.white,
      paper: colors.neutral.white,
      subtle: colors.neutral.gray50,
      hover: colors.neutral.gray100,
      accent: colors.background.lightPurple,
      chat: colors.background.slightPurple,
    },
    surface: {
      primary: colors.neutral.white,
      secondary: colors.neutral.gray50,
      tertiary: colors.neutral.gray100,
    },
    text: {
      primary: colors.neutral.gray900,
      secondary: colors.neutral.gray600,
      tertiary: colors.neutral.gray500,
      disabled: colors.neutral.gray400,
      inverse: colors.neutral.white,
    },
    border: {
      default: colors.neutral.gray200,
      light: colors.neutral.gray100,
      focus: colors.primary.blue,
    },
    divider: colors.neutral.gray200,
    status: {
      success: colors.semantic.success,
      error: colors.semantic.error,
      warning: colors.semantic.warning,
      info: colors.semantic.info,
    },
    priority: {
      critical: colors.semantic.error,
      high: colors.ui.orange,
      medium: colors.primary.blue,
      low: colors.neutral.gray500,
    },
    shadow: {
      small: 'rgba(0, 0, 0, 0.05)',
      medium: 'rgba(0, 0, 0, 0.1)',
      large: 'rgba(0, 0, 0, 0.15)',
    },
  },
};

const darkTheme = {
  name: 'dark',
  colors: {
    primary: {
      main: '#2563eb',
      hover: '#7395FF',
      light: '#1A2438',
      dark: '#1D4ED8',
    },
    secondary: {
      main: '#FF6B7A',
      hover: '#FF8A96',
      light: '#2D1F21',
    },
    background: {
      default: '#0A0B0E',
      paper: '#13151A',
      subtle: '#1A1C23',
      hover: '#1F2129',
      accent: '#1E2633',
      chat: '#161922',
    },
    surface: {
      primary: '#13151A',
      secondary: '#1A1C23',
      tertiary: '#1F2129',
    },
    text: {
      primary: '#F3F4F6',
      secondary: '#D1D5DB',
      tertiary: '#9CA3AF',
      disabled: '#6B7280',
      inverse: '#111827',
    },
    border: {
      default: '#2D3039',
      light: '#232530',
      focus: '#2563eb',
    },
    divider: '#2D3039',
    status: {
      success: '#34D399',
      error: '#F87171',
      warning: '#FBBF24',
      info: '#60A5FA',
    },
    priority: {
      critical: '#F87171',
      high: '#FB923C',
      medium: '#2563eb',
      low: '#9CA3AF',
    },
    shadow: {
      small: 'rgba(0, 0, 0, 0.2)',
      medium: 'rgba(0, 0, 0, 0.3)',
      large: 'rgba(0, 0, 0, 0.4)',
    },
  },
};

const getTheme = (mode = 'light') => {
  return mode === 'dark' ? darkTheme : lightTheme;
};

export { lightTheme, darkTheme, getTheme };
const theme = { lightTheme, darkTheme, getTheme };
export default theme;